import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const mediaQuery = (): MediaQueryList | null =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null;

export const prefersReducedMotion = (): boolean => mediaQuery()?.matches ?? false;

export const usePrefersReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    const query = mediaQuery();
    if (!query) return undefined;
    const onChange = () => setReduced(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return reduced;
};
